import { v4 as uuid } from 'uuid';
export class ProductAddon {
    id;
    name = null;
    price = 0;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export class ProductOptionValue {
    id = null;
    name = null;
    correction = 0;
    constructor(id, data) {
        this.id = id || null;
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export class ProductOption {
    id;
    name = null;
    possibleValues = [];
    minValues = 1;
    maxValues = 1;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value !== null && value !== undefined) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'possibleValues' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new ProductOptionValue(item.id, item));
                            }
                            value = items;
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
        if (this.minValues === null || this.minValues === undefined || Number.isNaN(Number(this.minValues))) {
            this.minValues = 1;
        }
        else {
            this.minValues = Math.max(0, Math.floor(Number(this.minValues)));
        }
        if (this.maxValues === undefined) {
            this.maxValues = 1;
        }
        else if (this.maxValues === null) {
            this.maxValues = null;
        }
        else if (Number.isNaN(Number(this.maxValues))) {
            this.maxValues = 1;
        }
        else {
            this.maxValues = Math.max(this.minValues, Math.floor(Number(this.maxValues)));
        }
    }
    isSingleSelect() {
        return this.minValues === 1 && this.maxValues === 1;
    }
    getValueById(id) {
        if (id) {
            for (let possibleValue of this.possibleValues) {
                if (possibleValue.id == id) {
                    return possibleValue;
                }
            }
        }
        return null;
    }
}
export class ProductSlotItem {
    id = null;
    productId = null;
    correction = 0;
    hidden = false;
    sortOrder = 0;
    constructor(id, data) {
        this.id = id || null;
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
export class ProductSlot {
    id;
    name = null;
    availableProducts = {};
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'availableProducts' && Object.values(value).length > 0) {
                            //Build a fresh map. Mutating `value` in place would write into
                            //the caller's reactive source (e.g. the Vue store's product
                            //data) every time a ProductSlot is constructed, which retriggers
                            //any computed that reads it — causing an infinite recompute loop.
                            let map = {};
                            for (let id in value) {
                                let item = value[id];
                                map[id] = new ProductSlotItem(item.id, item);
                            }
                            value = map;
                        }
                        // if (key == 'availableProducts' && Object.values(value).length > 0) {
                        //     //convert it from map to array with id
                        //     let idList = []
                        //     if (typeof value == 'object' && !Array.isArray(value)) {
                        //         for (let id in value) {
                        //             let o = value[id]
                        //             o.id = id
                        //             idList.push(o)
                        //         }
                        //     } else {
                        //         idList = value
                        //     }
                        //     let items = []
                        //     for (let item of idList as any) {
                        //         items.push(new ProductSlotItem(item.id, item))
                        //     }
                        //     value = items
                        // }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
    hasProductId(productId) {
        return this.availableProducts && Object.values(this.availableProducts).filter((a) => a.id == productId).length > 0;
        // return this.availableProducts.filter((a) => a.id == productId).length > 0
    }
    getSlotItemById(id) {
        if (id && this.availableProducts && this.availableProducts[id]) {
            return this.availableProducts[id];
        }
        return null;
        // if (id) {
        //     for (let item of this.availableProducts) {
        //         if (item.id == id) {
        //             return item
        //         }
        //     }
        // }
        // return null
    }
}
export var ProductType;
(function (ProductType) {
    ProductType["regular"] = "regular";
    ProductType["combined"] = "combined";
})(ProductType || (ProductType = {}));
export class Product {
    id = null;
    companyId = null;
    name = null;
    description = null;
    sortOrder = 0;
    type = ProductType.regular;
    price = 0;
    weight = 0;
    addons = [];
    options = [];
    slots = [];
    tags = null;
    vatRate = null;
    locationId = null;
    productionTime = null;
    productionTimeIsSplittable = true;
    productionTimeIsConstrainedToOpeningHours = false;
    categoryId = null;
    defaultCourseId = null;
    numberOfItemsInStock = null;
    stockOfSubproductsAffectCombinedProduct = true;
    constructor(id, data) {
        this.id = id || null;
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                        if (key == 'addons' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new ProductAddon(item.id, item));
                            }
                            value = items;
                        }
                        if (key == 'options' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new ProductOption(item.id, item));
                            }
                            value = items;
                        }
                        if (key == 'slots' && value.length > 0) {
                            let items = [];
                            for (let item of value) {
                                items.push(new ProductSlot(item.id, item));
                            }
                            value = items;
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
    getAddonById(addonId) {
        if (addonId) {
            for (let addon of this.addons) {
                if (addon.id == addonId) {
                    return addon;
                }
            }
        }
        return null;
    }
    getOptionById(optionId) {
        if (optionId) {
            for (let option of this.options) {
                if (option.id == optionId) {
                    return option;
                }
            }
        }
        return null;
    }
}
